export const MAX_PRICE_ALERT_PRECISION_VALUE = 16;
export const HIGH_SLIPPAGE_THRESHOLD = 5;
export const MAX_ORDERBOOK_PRECISION = 16;
export const MAX_TRADE_ASSETS = 20;
export const MAX_AUTO_INVEST_ASSETS = 20;
